import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class ProfileService {
    readAllProfiles(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.profilesResource, {}, sCallBack, eCallBack)
    }
}